import {
  hashStr,
  identifyAnonymousUserEvent,
  identifyEvent,
  isFullStoryLoaded,
  useSession,
} from '@finn/ui-utils';
import { Params } from 'next/dist/server/request/params';
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime';
import { ReadonlyURLSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import { getSlugsWithoutStep } from './pathHelper';

export const getHubspotDealInfo = (
  router: AppRouterInstance & { query?: { [key: string]: string } },
  params?: { slug?: string } | ReadonlyURLSearchParams | Params
) => {
  if (typeof params === 'object' && params !== null && !('slug' in params)) {
    return {
      contactId: undefined,
      dealId: undefined,
    };
  }

  if (router?.query?.contactId) {
    // should be a dead code block when all checkout pages are converted to CSR
    return {
      contactId: parseInt(router.query.contactId as string),
      dealId: parseInt(router.query.dealId as string),
    };
  } else {
    const paramsWithSlug = params as { slug?: string } | undefined;
    const [contactId, dealId] = getSlugsWithoutStep(
      paramsWithSlug?.slug || router?.query?.slug
    );

    return {
      contactId: parseInt(contactId),
      dealId: parseInt(dealId),
    };
  }
};

export const useUserIdentifierGeneralPages = () => {
  const [session, loading] = useSession();

  useEffect(() => {
    // session changes from undefined to null causing a duplicate
    if (session === undefined && loading) return;
    // router.asPath changes causing re-render and duplicate, need to check router.isReady
    // if (!router.isReady) return;
    // Check if the user is logged in and override the userId with the new logged-in user
    if (session?.user) {
      const userId = session.user.hs_contact_id;
      if (userId) {
        identifyEvent(String(userId), {
          name: session.user.name,
          email: session.user.email,
          eligible_for_jobauto: !!session.user?.is_job_auto,
          jobauto_company_id: session.user?.job_auto_company?.id,
          jobauto_company_name: session.user?.job_auto_company?.name,
          jobauto_company_domain: session.user?.job_auto_company?.domain,
          loggedIn: !!session,
        });
      } else {
        identifyAnonymousUserEvent({
          name: session.user.name,
          email: session.user.email,
          loggedIn: !!session,
        });
      }

      if (isFullStoryLoaded() && !!userId) {
        window.FS.identify(String(userId));
      }

      return;
    }

    identifyAnonymousUserEvent({
      loggedIn: !!session,
    });

    // Will use it as the user id from auth, since our auth doesn't return a user ID
    let hashedEmail = '';
    if (session?.user) {
      hashedEmail = hashStr(session.user.email);
    }

    // Add User ID to FullStory session recording
    if (isFullStoryLoaded() && !!hashedEmail) {
      window.FS.identify(hashedEmail);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session?.user?.email, loading]);
};
